<template>
  <div class="dashboard-editor-container">

    <el-row
      type="flex"
      justify="space-between"
      style="background:#fff; padding:16px 0 0 0; margin-bottom:32px;"
    >
     <el-col :span="6" v-for="(item,index) in cardData" :key="index" style="padding: 0;">
        <CoreCard :cardInfo="item"/>
      </el-col>
    </el-row>

    <el-row style="background:#fff;padding:16px 16px 0;margin-bottom:32px;">
        <el-col :xs="24" :sm="24" :lg="24">
          <BarChart
              :key="barChartKey"
              :chart-data="barChartData"
              :chart-info="{ title: '当日工厂生产进度统计' }"
            />
        </el-col>
      </el-row>
    <el-row style="background:#fff;padding:16px 16px 0;margin-bottom:32px;">
      <el-col :xs="24" :sm="24" :lg="24">
        <LineChart
          :chart-data="gatherRateChart"
          :chart-info="{ title: '当年按月采集率（%）', yAxisMax: 100, valueSuffix: '%' }"
        />
      </el-col>
    </el-row>
       <el-row style="background:#fff;padding:16px 16px 0;margin-bottom:32px;">
      <el-col :xs="24" :sm="24" :lg="24">
        <LineChart
          :chart-data="{
            xAxis: lineChartData.xAxisData,
            series: [
              { name: '生产数量', data: lineChartData.seriesDataOne },
              { name: '发货数量', data: lineChartData.seriesDataTwo }
            ]
          }"
          :chart-info="{ title: '近30天每日产量和发货量趋势' }"
        />
      </el-col>
    </el-row>

    <el-row style="background:#fff;padding:16px 16px 0;margin-bottom:32px;">
      <el-col :xs="24" :sm="24" :lg="24">
        <ProductionList />
      </el-col>
    </el-row>
  </div>
</template>

<script>
import ProductionList from "./productionList.vue";
import CoreCard  from"../components/CoreCard.vue";
import LineChart  from"../components/LineChart.vue";
import BarChart from '../components/BarChart.vue';
import {
  workCountCurDay,
  workPlanCountCurDay,
  factoryWorkOutCountCurDay,
  workAndOutCount30Day
} from "@/api/board";
import { samplingrate } from "@/api/plant";

function calcRate(count, produce) {
  const c = Number(count) || 0;
  const p = Number(produce) || 0;
  if (p <= 0) {
    return 0;
  }
  return Number(((c / p) * 100).toFixed(2));
}

function formatDate(d) {
  const y = d.getFullYear();
  const m = `${d.getMonth() + 1}`.padStart(2, '0');
  const day = `${d.getDate()}`.padStart(2, '0');
  return `${y}-${m}-${day}`;
}

/** 汇总 samplingrate 返回列表（多工厂分组时不能只取 [0]） */
function sumSamplingRateRows(list) {
  const empty = {
    package_level1_count: 0,
    package_level1_produce: 0,
    package_level2_count: 0,
    package_level2_produce: 0,
    package_level3_count: 0,
    package_level3_produce: 0
  };
  if (!Array.isArray(list) || list.length === 0) {
    return empty;
  }
  return list.reduce((acc, row) => {
    if (!row) {
      return acc;
    }
    acc.package_level1_count += Number(row.package_level1_count ?? row.packageLevel1Count) || 0;
    acc.package_level1_produce += Number(row.package_level1_produce ?? row.packageLevel1Produce) || 0;
    acc.package_level2_count += Number(row.package_level2_count ?? row.packageLevel2Count) || 0;
    acc.package_level2_produce += Number(row.package_level2_produce ?? row.packageLevel2Produce) || 0;
    acc.package_level3_count += Number(row.package_level3_count ?? row.packageLevel3Count) || 0;
    acc.package_level3_produce += Number(row.package_level3_produce ?? row.packageLevel3Produce) || 0;
    return acc;
  }, { ...empty });
}

export default {
  name: "ProductionMonitoring",
  components: {
    CoreCard,
    LineChart,
    BarChart,
    ProductionList
  },
  data() {
    return {
    cardData:[
          {
            titleOne:"实际产量",
            numOne:0,
            titleTwo:"计划产量",
            numTwo:0,
            ratioLabel:"完成率"
          },
          {
            titleOne:"1级采集成功率",
            numOne:'0%',
            marginTop:'0%'
          },
          {
            titleOne:"2级采集成功率",
            numOne:'0%',
            marginTop:'0%'
          },
          {
            titleOne:"3级采集成功率",
            numOne:'0%',
            marginTop:'0%'
          },
      ],
      barChartKey: 0,
      barChartData: {
        xAxis: ["工厂一", "工厂二", "工厂三", "工厂四", "工厂五", "工厂六"],
        series: [
          { name: "计划产量", data: [0, 0, 0, 0, 0, 0] },
          { name: "实际产量", data: [0, 0, 0, 0, 0, 0]},
        ]
      },
      gatherRateChart: {
        xAxis: ['1月', '2月', '3月', '4月', '5月','6月', '7月', '8月', '9月', '10月', '11月', '12月'],
        series: [
          { name: '1级采集率', data: [0,0,0,0,0,0,0,0,0,0,0,0] },
          { name: '2级采集率', data: [0,0,0,0,0,0,0,0,0,0,0,0] },
          { name: '3级采集率', data: [0,0,0,0,0,0,0,0,0,0,0,0] }
        ]
      },
      lineChartData: {
        xAxisData: [],
        seriesDataOne: [],
        seriesDataTwo: []
      }
    };
  },


  mounted() {
    this.getWorkCountCurDay();
    this.getWorkPlanCountCurDay();
    this.getFactoryWorkOutCountCurDay();
    this.getWorkAndOutCount30Day();
    this.getGatherRateCurDay();
    this.getGatherRateCurYearByMonth();
  },
  methods: {

    getWorkCountCurDay(){
     workCountCurDay().then(response => {
        if(response && response.status_code == 200 && response.data!=null){
          this.cardData[0].numOne = response.data;
        }
      });
    },
    getWorkPlanCountCurDay(){
     workPlanCountCurDay().then(response => {
        if(response && response.status_code == 200 && response.data!=null){
          this.cardData[0].numTwo = response.data;
        }
      });
    },

    // 当日采集率：复用已有工单采集率接口 samplingrate（workorder_senior.package_levelN_count/produce）
    getGatherRateCurDay(){
      const today = formatDate(new Date());
      samplingrate({
        start_time: today,
        end_time: today
      }).then(response => {
        if (!response || (response.status_code != null && response.status_code !== 200)) {
          return;
        }
        const row = sumSamplingRateRows(response.data);
        this.cardData[1].numOne = calcRate(row.package_level1_count, row.package_level1_produce) + '%';
        this.cardData[2].numOne = calcRate(row.package_level2_count, row.package_level2_produce) + '%';
        this.cardData[3].numOne = calcRate(row.package_level3_count, row.package_level3_produce) + '%';
      }).catch(() => {});
    },

    // 当年按月采集率：一次 samplingrate(groupByMonth=1) 按月汇总，避免并行 12 次请求失败被当成 0
    getGatherRateCurYearByMonth(){
      const year = new Date().getFullYear();
      samplingrate({
        start_time: `${year}-01-01`,
        end_time: `${year}-12-31`,
        groupByMonth: 1
      }).then(response => {
        const level1 = Array(12).fill(0);
        const level2 = Array(12).fill(0);
        const level3 = Array(12).fill(0);
        if (!response || (response.status_code != null && response.status_code !== 200)) {
          this.gatherRateChart = {
            xAxis: ['1月', '2月', '3月', '4月', '5月','6月', '7月', '8月', '9月', '10月', '11月', '12月'],
            series: [
              { name: '1级采集率', data: level1 },
              { name: '2级采集率', data: level2 },
              { name: '3级采集率', data: level3 }
            ]
          };
          return;
        }
        const list = Array.isArray(response.data) ? response.data : [];
        list.forEach(row => {
          if (!row) return;
          const month = Number(row.rate_month ?? row.rateMonth) || 0;
          if (month < 1 || month > 12) return;
          const i = month - 1;
          level1[i] = calcRate(row.package_level1_count ?? row.packageLevel1Count, row.package_level1_produce ?? row.packageLevel1Produce);
          level2[i] = calcRate(row.package_level2_count ?? row.packageLevel2Count, row.package_level2_produce ?? row.packageLevel2Produce);
          level3[i] = calcRate(row.package_level3_count ?? row.packageLevel3Count, row.package_level3_produce ?? row.packageLevel3Produce);
        });
        this.gatherRateChart = {
          xAxis: ['1月', '2月', '3月', '4月', '5月','6月', '7月', '8月', '9月', '10月', '11月', '12月'],
          series: [
            { name: '1级采集率', data: level1 },
            { name: '2级采集率', data: level2 },
            { name: '3级采集率', data: level3 }
          ]
        };
      }).catch(() => {});
    },

    getWorkAndOutCount30Day(){
      workAndOutCount30Day().then(response => {
        if(response && response.status_code == 200 && response.data){
          const chartData = {
            xAxisData: [],
            seriesDataOne: [],
            seriesDataTwo: []
          };
          for (let i = 0; i < response.data.length; i++) {
            chartData.seriesDataOne.push(response.data[i].workCount || 0);
            chartData.seriesDataTwo.push(response.data[i].outCount || 0);
            let createDate = response.data[i].createDate || '';
            if (typeof createDate === 'string' && createDate.length > 10) {
              createDate = createDate.substring(0, createDate.length - 8);
            }
            chartData.xAxisData.push(createDate);
          }
          this.lineChartData = chartData;
        }
      });
    },

    getFactoryWorkOutCountCurDay(){
     factoryWorkOutCountCurDay().then(response => {
        if(response && response.status_code == 200 && response.data!=null) {
          const factories = [];
          const workPlanData = [];
          const workActualData = [];
                
          response.data.forEach(item => {
            factories.push(item.factory);
            workPlanData.push(item.workPlanCountCurDay || 0);
            workActualData.push(item.workCountCurDay || 0);
          });
      
          this.barChartData = {
            ...this.barChartData,
            xAxis: factories,
            series: [
              { ...this.barChartData.series[0], data: workPlanData },
              { ...this.barChartData.series[1], data: workActualData }
            ]
          };
          
          this.barChartKey += 1;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.dashboard-editor-container {
  padding: 32px;
  background-color: rgb(240, 242, 245);
  position: relative;

  .github-corner {
    position: absolute;
    top: 0px;
    border: 0;
    right: 0;
  }
  .chart-wrapper {
    background: #fff;
    padding: 16px 16px 0;
    margin-bottom: 32px;
  }
}
</style>
